package one.healthium.ui.compose.theme.styles

import androidx.compose.foundation.shape.RoundedCornerShape
import androidx.compose.runtime.Composable
import androidx.compose.ui.graphics.Color
import androidx.compose.ui.graphics.Shape
import androidx.compose.ui.unit.Dp
import androidx.compose.ui.unit.dp
import one.healthium.ui.compose.theme.gray_2

data class BannerStyle(
    private val containerColor: Color? = null,
    private val shape: Shape? = null,
    private val elevation: Dp? = null,
) {
    val containerColorOrDefault: Color
        @Composable get() = containerColor ?: gray_2

    val shapeOrDefault: Shape
        @Composable get() = shape ?: RoundedCornerShape(12.dp)

    val elevationOrDefault: Dp
        @Composable get() = elevation ?: 8.dp
}
